
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("bDxwy", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $18469461aa46bb94$export$2e2bcd8739ae039);

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $gtD4K = parcelRequire("gtD4K");


var $eEA8O = parcelRequire("eEA8O");


var $7aRa9 = parcelRequire("7aRa9");


var $7zgzO = parcelRequire("7zgzO");


var $4MlWS = parcelRequire("4MlWS");

const $18469461aa46bb94$var$NetworkStatusFlag = (0, $3u0dr.isReactCompilerActiveV1)() ? function NetworkStatusFlag(t0) {
    const $ = (0, $frIzR.c)(11);
    const { flags: flags, status: status } = t0;
    const { match: route } = (0, $42omo.useContext)((0, $7zgzO.RoutesContext));
    let messages;
    if ($[0] !== route?.name || $[1] !== status) {
        bb0: switch(status){
            case (0, $4MlWS.ClientNetworkStatus).IP_BLOCKED:
                if (!route?.name?.startsWith("EDIT_")) messages = $18469461aa46bb94$var$ipBlockedMessages;
                break bb0;
            case (0, $4MlWS.ClientNetworkStatus).RATE_LIMITED:
                messages = $18469461aa46bb94$var$rateLimitedMessages;
        }
        $[0] = route?.name;
        $[1] = status;
        $[2] = messages;
    } else messages = $[2];
    let t1;
    if ($[3] !== flags || $[4] !== messages || $[5] !== status) {
        t1 = ()=>{
            if (messages) flags.showErrorFlag({
                id: `NetworkStatusFlag-${status}`,
                title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), messages.title),
                description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
                    ...messages.description,
                    values: {
                        refreshLink: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eEA8O.default), {
                            appearance: "link",
                            onClick: $18469461aa46bb94$var$reloadPage,
                            spacing: "none"
                        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), messages.refreshLinkText))
                    }
                })
            });
        };
        $[3] = flags;
        $[4] = messages;
        $[5] = status;
        $[6] = t1;
    } else t1 = $[6];
    let t2;
    if ($[7] !== flags || $[8] !== messages || $[9] !== status) {
        t2 = [
            flags,
            messages,
            status
        ];
        $[7] = flags;
        $[8] = messages;
        $[9] = status;
        $[10] = t2;
    } else t2 = $[10];
    (0, $42omo.useEffect)(t1, t2);
    return null;
} : function NetworkStatusFlag({ flags: flags, status: status }) {
    const { match: route } = (0, $42omo.useContext)((0, $7zgzO.RoutesContext));
    let messages;
    switch(status){
        case (0, $4MlWS.ClientNetworkStatus).IP_BLOCKED:
            // Derisk the flag by not displaying it on full-page editors because they
            // (may) have an EditorConnectionBanner:
            if (!route?.name?.startsWith('EDIT_')) messages = $18469461aa46bb94$var$ipBlockedMessages;
            break;
        case (0, $4MlWS.ClientNetworkStatus).RATE_LIMITED:
            messages = $18469461aa46bb94$var$rateLimitedMessages;
            break;
    }
    (0, $42omo.useEffect)(()=>{
        if (messages) flags.showErrorFlag({
            id: `NetworkStatusFlag-${status}`,
            title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), messages.title),
            description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
                ...messages.description,
                values: {
                    refreshLink: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eEA8O.default), {
                        appearance: "link",
                        onClick: $18469461aa46bb94$var$reloadPage,
                        spacing: "none"
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), messages.refreshLinkText))
                }
            })
        });
    }, [
        flags,
        messages,
        status
    ]);
    return null;
};
var // Reduce critical path bundle/file size:
// eslint-disable-next-line import/no-default-export
$18469461aa46bb94$export$2e2bcd8739ae039 = (0, $7aRa9.withFlags)($18469461aa46bb94$var$NetworkStatusFlag);
const $18469461aa46bb94$var$ipBlockedMessages = (0, $cgtv4.defineMessages)({
    description: {
        id: "network-status-listener.flag.description.ip-blocked",
        defaultMessage: "Check your network connection, {refreshLink}, and try again. If the problem persists, contact your administrator for help."
    },
    refreshLinkText: {
        id: "network-status-listener.flag.refresh-link-text.ip-blocked",
        defaultMessage: "refresh"
    },
    title: {
        id: "network-status-listener.flag.title.ip-blocked",
        defaultMessage: "There was a problem accessing this content"
    }
});
const $18469461aa46bb94$var$rateLimitedMessages = (0, $cgtv4.defineMessages)({
    description: {
        id: "network-status-listener.flag.description.rate-limited",
        defaultMessage: "Rate limit reached. Wait a minute or so while the system resets, {refreshLink}, and try again."
    },
    refreshLinkText: {
        id: "network-status-listener.flag.refresh-link-text.rate-limited",
        defaultMessage: "refresh"
    },
    title: {
        id: "network-status-listener.flag.title.rate-limited",
        // TODO: replace straight quotes with curly quotes (see go/curlyquotes)
        // eslint-disable-next-line no-restricted-syntax
        defaultMessage: "We couldn\u2019t load this content"
    }
});
function $18469461aa46bb94$var$reloadPage() {
    window.location.reload();
}

});


//# sourceMappingURL=NetworkStatusFlag.6844086d.js.map
